// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3Q-7t","boxTitle":"Qualiphy_boxTitle__269-i","box":"Qualiphy_box__2p_09","toggleWrap":"Qualiphy_toggleWrap__1tyam"};